import React, { Fragment, useEffect, useRef, useState } from 'react'
import { Carousel } from 'antd'
import Image from 'next/image'
import { Icon } from '@iconify/react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useTranslation } from 'src/utils/i18n'
import NewFooter from 'src/components/android-step/newFooter'
import { styled } from '@mui/material'

const ScrollDiv = styled('div')({
  '@media (max-width: 600px)': {
    '-msOverflowStyle': 'none',  /* 适用于 IE 和 Edge */
    scrollbarWidth: 'none',  /* 适用于 Firefox */
    '&::-webkit-scrollbar': {
      display: 'none', /* 适用于 WebKit 浏览器（如 Chrome、Safari 和新版 Edge） */
    }
  }
})

function One(data) {
  const { t } = useTranslation('commonAndroid')

  const step = [
    {
      title: t(
        "<div style='line-height: 20px;'><p style='font-weight: 600;display: inline-block;margin-right:3px;'>Pull down</p>the extended menu from the top of the screen.</div>"
      ),
      img: [
        {
          src: '/images/android/five/1.png'
        }
      ]
    },
    {
      title: t(
        "<div style='line-height: 20px;'><p style='font-weight: 600;display: inline-block;margin-right:3px;'>Pull down again</p>until you see<p style='font-weight: 600;display: inline-block;margin-left:3px;'>Location,</p>&nbsp;then<p style='font-weight: 600;display: inline-block;margin-left:3px;'>enable Location.</p></div>"
      ),
      img: [
        {
          src: '/images/android/five/2.png'
        },
        {
          src: '/images/android/five/2.1.png'
        }
      ]
    }
  ]

  const imgToggle = useRef()

  const [currentSlide, setcurrentSlide] = useState(0)

  const [carousel, setCarousel] = useState(step[0].img)

  const [autoplay, setAutoplay] = useState(true)

  const Handler = index => {
    if (index !== 6) {
      setCarousel(step[index].img)
      setcurrentSlide(index)
      setImg(0)

      imgToggle.current.goTo(0)

      /* imgToggle.current.goTo(index) */
    } else {
      /* imgToggle.current.goTo(0) */
      setCarousel(step[index].img)
      setcurrentSlide(index)
    }
  }

  const { query } = useRouter()

  const [a, setA] = useState(1)

  useEffect(() => {
    const interval = setInterval(() => {
      if (autoplay === true) {
        if (parseInt(currentSlide) === 1) {
          setCarousel(step[0].img)
          setcurrentSlide(0)
          setImg(0)
          imgToggle.current.goTo(0)
        } else if (parseInt(currentSlide) === 0) {
          setCarousel(step[currentSlide + 1].img)
          setcurrentSlide(currentSlide + 1)
          setImg(0)
          imgToggle.current.goTo(0)
        }
      }
    }, [parseInt(currentSlide) !== 1 ? 3000 : 6000])

    // 清除定时器以避免内存泄漏
    return () => clearInterval(interval)
  }, [currentSlide, carousel, query, a, autoplay])

  const [Img, setImg] = useState(0)

  useEffect(() => {
    let startX

    const handleTouchStart = e => {
      // 记录触摸起始位置
      startX = e.touches[0].clientX
    }

    const handleTouchMove = e => {
      // 计算触摸移动距离
      e.preventDefault()

      const currentX = e.touches[0].clientX
      const deltaX = currentX - startX

      // 根据 deltaX 判断左右滑动
      if (deltaX > 0) {
        if (parseInt(currentSlide) === 1) {
          if (parseInt(Img) === 0 && parseInt(Img + 1) !== carousel.length) {
            setCarousel(step[0].img)
            setcurrentSlide(0)
            setImg(0)
            imgToggle.current.goTo(0)
          } else {
            setImg(0)
          }
        } else if (parseInt(currentSlide) === 0) {
          /* setcurrentSlide(currentSlide + 1)
          setCarousel(step[currentSlide + 1].img)
          setcurrentSlide2(0) */
          setCarousel(step[1].img)
          setcurrentSlide(1)
          setImg(0)
        }
      } else if (deltaX < 0) {
        if (parseInt(currentSlide) === 1) {
          if (parseInt(Img) + 1 === carousel.length) {
            setCarousel(step[0].img)
            setcurrentSlide(0)
            setImg(0)
          }
        } else if (parseInt(currentSlide) === 0) {
          setcurrentSlide(1)
          setCarousel(step[1].img)
          imgToggle.current.goTo(0)
        }
      }
    }

    // 添加事件监听器
    document.addEventListener('touchstart', handleTouchStart)
    document.addEventListener('touchmove', handleTouchMove)

    // 清理工作
    return () => {
      document.removeEventListener('touchstart', handleTouchStart)
      document.removeEventListener('touchmove', handleTouchMove)
    }
  }, [currentSlide, carousel, query, a, Img])

  const StepProgress = ({ current = 5, total = 6 }) => {
    const barWidth = 72 // 宽度

    return (
      <div className="flex items-center justify-center gap-4 mb-[40px] Mlg:mb-[20px]">
        <div className="text-[20px] leading-[30px] font-medium text-[#484B60] Mlg:text-[16px] Mlg:leading-[24px] ">
          {current}/{total}
        </div>

        <div className="flex gap-x-[6px]">
          {Array.from({ length: total }).map((_, i) => {
            const active = i < current;

            return (
              <div
                key={i}
                className="h-[4px] w-[72px] Mlg:w-[42.17px] rounded-[1px]"
                style={
                  active
                    ? {
                      background: "linear-gradient(90deg, #09A6EA 1.56%, #6838F2 47.99%)",
                      backgroundSize: `${current * barWidth}px 4px`,
                      backgroundPosition: `-${i * barWidth}px 0px`,
                    }
                    : {
                      background: "#E8EDFF",
                    }
                }
              />
            )
          })}
        </div>
      </div>
    )
  }

  return (
    <Fragment>
      <StepProgress />
      <ScrollDiv
        className={`w-[620px] Ssm:w-[100%] mx-auto justify-between setup overflow-auto pb-[132px] h-full p-[0px_15px_15px_15px] max-w-[1440px]`}
      >
        {data.fullScreen && (
          <Icon
            onClick={() => {
              data.setFullScreen(false)
            }}
            icon='maki:cross'
            className={` absolute top-2 right-3 w-[20px] h-[20px] text-black/30`}
          />
        )}

        <div
          onMouseEnter={() => {
            setAutoplay(false), setA(0)
          }}
          onMouseLeave={() => {
            setAutoplay(true), setA(1)
          }}
          className={`w-full text-black Ssm:w-[100%] mx-auto setup ${data.fullScreen ? 'grid mx-auto justify-center' : ' Smd:flex justify-between'
            }`}
        >
          <div className={`w-[343px] ${data.fullScreen ? 'order-2 w-[80%] mx-auto' : 'Dsm:w-[100%] Ssm:mx-auto'}`}>
            <p
              className={`text-[24px] Dsm:text-[20px] pb-[10px] font-[600] Ssm:text-center  ${data.fullScreen ? 'hidden' : ''
                }`}
            >
              {t('Turn on Location')}
            </p>
            <div className={`pl-1 ${data.fullScreen ? 'pt-[20px]' : 'Dsm:pt-[5px] Dsm:w-[96%] mx-auto pt-[5px]'}`}>
              {step.map((item, index) => {
                return (
                  <div
                    onClick={() => Handler(index)}
                    key={index}
                    className={`flex text-[14px] cursor-pointer  ${data.fullScreen ? 'mt-[10px]' : ' mt-[7px] Dsm:mt-[10px]'
                      }`}
                  >
                    <div className='flex'>
                      <p
                        className={`w-[24px] h-[22px] rounded-full flex items-center justify-center ${currentSlide === index && 'bg-[#2A99FF] text-white'
                          }`}
                      >
                        {index + 1}.
                      </p>
                      <div
                        className={`ml-1 w-[100%]  ${data.fullScreen ? 'text-[13px]' : 'text-[13px]'}`}
                        dangerouslySetInnerHTML={{ __html: item.title }}
                      />
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
          <div
            className={`w-[221px] h-[506px] rounded-[24px] p-[6px] border-[1px] border-[#ACB1BD] relative  ${data.fullScreen ? 'order-1 mx-auto' : 'Ssm:hidden'
              }`}
          >
            <Carousel
              autoplay={autoplay}
              className='flex rounded-[15px] border-[#ACB1BD] overflow-hidden border-[1px] w-[207px] h-[449px]'
              ref={imgToggle}
              cancelable={false}
              afterChange={index => { }}
              beforeChange={(index, index2) => {
                setImg(index2)
              }}
            >
              {carousel.map((item, index) => {
                return (
                  <div key={index} className=' rounded-[15px]'>
                    <Image
                      alt='img'
                      width={100}
                      height={100}
                      src={item.src}
                      className='mx-auto w-[207px] h-[447px] rounded-[15px]'
                    />
                  </div>
                )
              })}
            </Carousel>
            <div className='flex items-center justify-center mt-5'>
              {step.map((item, index) => {
                return (
                  <div
                    key={index}
                    onClick={() => {
                      setCarousel(step[index].img), setcurrentSlide(index), setImg(0), imgToggle.current.goTo(0)
                    }}
                    className={`border-[1px] ${index !== 0 && 'ml-2'
                      } border-[#2A99FF] w-[12px] h-[12px] cursor-pointer rounded-[15px] ${currentSlide === index && 'bg-[#2A99FF]'
                      } `}
                  ></div>
                )
              })}
            </div>
            <div className='absolute -left-[3px] top-[55px]'>
              <Image src='/images/android/1.svg' className='w-[5px] h-[24px]' width={100} height={100} alt='img' />
              <Image src='/images/android/1.svg' className='w-[5px] h-[24px] mt-4' width={100} height={100} alt='img' />
            </div>
          </div>
        </div>

        <div className={`flex flex-col items-center Smd:hidden ${data.fullScreen && 'hidden'}`} onClick={() => data.setFullScreen(true)}>
          <Image
            src='/images/bind/watch.svg'
            width={100}
            height={100}
            alt='watch'
            className='mx-auto w-[58px] mt-[36px]'
          />
          <p className='mt-[14px] text-[14px] text-[#454CFF] font-[600]'>{t('Watch a tutorial')}</p>
        </div>

      </ScrollDiv>

      <NewFooter nowPage={data.nowPage} setNowPage={data.setNowPage} startMonitoring={data.startMonitoring} />
    </Fragment>
  )
}

export default One
